// extracted by mini-css-extract-plugin
export default {"tenantHeader":"DayTenant_tenantHeader__Nq7F+","tenantUL":"DayTenant_tenantUL__a4h2-"};